var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 25.3327H8.34802L21.9967 11.684L20.3147 10.002L6.66602 23.6507V25.3327ZM5.87135 27.3327C5.52979 27.3327 5.24357 27.2171 5.01268 26.986C4.78157 26.7551 4.66602 26.4689 4.66602 26.1273V23.8173C4.66602 23.4922 4.72846 23.1823 4.85335 22.8877C4.97802 22.593 5.14979 22.3362 5.36868 22.1173L22.2533 5.24035C22.4549 5.05724 22.6775 4.91579 22.921 4.81602C23.1648 4.71602 23.4203 4.66602 23.6877 4.66602C23.955 4.66602 24.2139 4.71346 24.4643 4.80835C24.715 4.90324 24.9369 5.05413 25.13 5.26101L26.7583 6.90968C26.9652 7.10279 27.1127 7.32502 27.2007 7.57635C27.2887 7.82768 27.3327 8.07902 27.3327 8.33035C27.3327 8.59857 27.2869 8.85446 27.1953 9.09802C27.1038 9.34179 26.9581 9.56446 26.7583 9.76602L9.88135 26.63C9.66246 26.8489 9.40568 27.0207 9.11102 27.1453C8.81635 27.2702 8.50646 27.3327 8.18135 27.3327H5.87135ZM21.141 10.8577L20.3147 10.002L21.9967 11.684L21.141 10.8577Z",
    fill: "#252B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEdit);
export default __webpack_public_path__ + "static/media/dark-edit.3553be9fb50a61acb39c01b7068108f8.svg";
export { ForwardRef as ReactComponent };